import React, { useState } from 'react';
import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonContent, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonList, IonListHeader, IonModal, IonTitle, IonToolbar, IonicSlides } from '@ionic/react';

import location from '../assets/location-pin.svg'
import './CardTurCom.css'
import { PlatilloQRooProps } from '../../src/interfaces';
import { arrowBack, callSharp, cellularSharp, desktopSharp, linkSharp, logoFacebook, logoInstagram, logoPinterest, logoSnapchat, logoTiktok, logoTwitter, logoWhatsapp, logoYoutube, mailSharp, mapSharp } from 'ionicons/icons';
import closePage from '../assets/close-circle.svg'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/controller'
import { Autoplay, Keyboard, Pagination, Scrollbar, Zoom } from 'swiper';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/zoom';
import '@ionic/react/css/ionic-swiper.css';

function CardPlatilloQRoo({nombrePlatillo, chef, localidad, estado, latitud, longitud, descripcion, imagenPlatillo, ingredientes, imagenesIngredientes, procedimiento } : PlatilloQRooProps) {
  const [isOpen1, setIsOpen1] = useState(false);
  console.log("CardPlatilloQRoo");
  
  return (
    <>
      <IonCard id='cardArt' color="light" onClick={() => setIsOpen1(true)} /*routerLink='/Menu'*/ >
        <img className="CardRes" alt={nombrePlatillo} src={imagenPlatillo[0]} />
        <IonCardHeader>
          <IonCardTitle>{nombrePlatillo}</IonCardTitle>
        </IonCardHeader>

        <IonCardContent>
            <div className="open">
              {localidad}, {estado}
            </div>
            <div className="open">
              <p>{nombrePlatillo}</p>
            </div>
        </IonCardContent>
      </IonCard>

      <IonModal isOpen={isOpen1} keepContentsMounted={true}>
        <IonHeader className='art-ion-header'>
          <IonToolbar className='name-header-modal1 toolbar-modal-tour'>
              <IonButtons className='button-close'>
                <IonButton className='text-close-tour' onClick={() => setIsOpen1(false)}>
                  <img src={closePage} alt="imageClose" id='icon-close' />
                </IonButton>
              </IonButtons>

              <Swiper
                // spaceBetween={5}
                modules={[Autoplay, Keyboard, Pagination, Scrollbar, Zoom, IonicSlides]}
                autoplay={true}
                keyboard={true}
                pagination={{
                  dynamicBullets: true,
                }}
                scrollbar={true}
                zoom={true}
                slidesPerView={1}
                onSlideChange={() => console.log('slide change')}
                onSwiper={(swiper) => console.log(swiper)}
              >
              {imagenPlatillo.map((element, index) => 
            <>
              <SwiperSlide>
                <IonCard id='swiper-ioncard'>
                <img className="img-swiper" alt={nombrePlatillo} src={element} />
                  <IonCardHeader>
                    <IonCardTitle>{nombrePlatillo}</IonCardTitle>
                  </IonCardHeader>
                </IonCard>
              </SwiperSlide>
                </>
              )
              }
              </Swiper>
            <IonTitle>
                <div className="open">
                        {nombrePlatillo}
                </div>
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        
        <IonContent fullscreen={true} className="ion-padding">
        
        <h3>{nombrePlatillo}</h3>
        <IonList>
            <IonItem>
            <p>
                {descripcion}
            </p>
            </IonItem>
        </IonList>

        <h3>Ingredientes</h3>
              <Swiper
                // spaceBetween={5}
                modules={[Autoplay, Keyboard, Pagination, Scrollbar, Zoom, IonicSlides]}
                autoplay={true}
                keyboard={true}
                pagination={{
                  dynamicBullets: true,
                }}
                scrollbar={true}
                zoom={true}
                slidesPerView={1}
                onSlideChange={() => console.log('slide change')}
                onSwiper={(swiper) => console.log(swiper)}
              >
              {imagenesIngredientes.map((element, index) => 
            <>
              <SwiperSlide>
                <IonCard id='swiper-ioncard'>
                <img className="img-swiper" alt='Hola' src={element} />
                  <IonCardHeader>
                    <IonCardTitle>{ingredientes[index]}</IonCardTitle>
                  </IonCardHeader>
                </IonCard>
              </SwiperSlide>
                </>
              )
              }
              </Swiper>

        <IonList className='Incluye padd-incluye'>
          <IonListHeader>
            <IonLabel className='title-incluye'>Procedimiento: </IonLabel>
          </IonListHeader>
            <IonItem className="terciary">
                <h5>{procedimiento}</h5>
            </IonItem>
          
        </IonList>

        </IonContent>
      </IonModal>
    
    
    </>

  );
}


export default CardPlatilloQRoo;
